/*
 * @Author: lbh
 * @Date: 2025-04-28 15:55:07
 * @LastEditors: lbh
 * @LastEditTime: 2025-04-28 15:56:43
 * @Description: file content
 */
import { throttle } from "lodash-es";

import rfdc from "rfdc";
const clone = rfdc(); // 初始化深拷贝函数

export const lodash = {
  throttle: throttle,
  clone: clone,
};

export default {
  install(Vue) {
    Vue.prototype.$lodash = lodash;
  },
};
